import styled from 'styled-components';

export const EmptyStateContainer = styled.div<{ $isCompact?: boolean }>`
  text-align: center;
  padding: ${({ $isCompact }) => ($isCompact ? '2.5rem 1.5rem' : '4rem 2rem')};
  color: ${({ $isCompact, theme }) =>
    $isCompact ? theme.colors.text.secondary : '#999'};
`;

export const EmptyStateIcon = styled.div<{ $isCompact?: boolean }>`
  font-size: ${({ $isCompact }) => ($isCompact ? '2.25rem' : '4rem')};
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '0.5rem' : '1rem')};
`;

export const EmptyStateText = styled.div`
  margin-bottom: 0.5rem;
`;

export const EmptyStateSubtext = styled.div`
  margin-top: 0.5rem;
`;


